import classNames from 'classnames';
import React from 'react';
import InfoText from '../../atoms/InfoText';

export const STATUS_VARIANTS = {
  success: 'success',
  info: 'info',
  warning: 'warning',
  error: 'error',
};

const primaryStyles = {
  [STATUS_VARIANTS.info]: {
    bg: '!bg-blue-500',
  },
  [STATUS_VARIANTS.error]: {
    bg: '!bg-light-warning',
  },
  [STATUS_VARIANTS.success]: {
    bg: '!bg-light-success',
  },
  [STATUS_VARIANTS.warning]: {
    bg: 'bg-light-alert',
  },
};

const secondaryStyles = {
  [STATUS_VARIANTS.info]: {
    color: `!text-[#3C91E6]`,
    bg: `!bg-[#F3F6FD]`,
  },
  [STATUS_VARIANTS.warning]: {
    color: `!text-[#F58F29]`,
    bg: `!bg-[#FDEFE7]`,
  },
};

export type statusVariant = 'success' | 'info' | 'warning' | 'error';

export default function Status({
  text,
  type = 'primary',
  variant = 'info',
}: {
  text: string;
  type?: 'primary' | 'secondary';
  variant?: statusVariant;
}) {
  console.log(
    'qqqqqqqqqqqqq',
    `!bg-[${secondaryStyles[variant]?.bg}]`,
    variant
  );
  return (
    <div
      className={classNames(
        'px-2 py-1 rounded ',
        type === 'primary'
          ? primaryStyles[variant]?.bg || 'bg-light-information'
          : secondaryStyles[variant]?.bg || 'bg-light-information'
      )}
    >
      <InfoText
        text={text}
        className={classNames(
          type === 'primary'
            ? '!text-light-button-label-primary'
            : secondaryStyles[variant]?.color
        )}
        size="xs"
      />
    </div>
  );
}
